import i18next from "i18next";

const getDocName = (doc) => {
  if (!doc) return "";
  return doc[`name_${i18next.language.split("-")[0]}`];
};

export default getDocName;
